import React from 'react';
import PropTypes from 'prop-types';
import { Permissions } from '@upstart/harmony/lib/constants';
import { SplitButton } from 'react-bootstrap/lib';
import DeleteButton from './DeleteButton';
import withFeedPermission from './feedPermission';

function EditButton({ feedMapping, onEdit, onDelete }) {
  return (
    <div>
      <SplitButton
        title="Edit"
        key={feedMapping.id}
        id={`split-button-basic-${feedMapping.id}`}
        onClick={() => {
          onEdit(feedMapping.id);
        }}
      >
        <DeleteButton feedMapping={feedMapping} onDelete={onDelete} />
      </SplitButton>
    </div>
  );
}

EditButton.propTypes = {
  feedMapping: PropTypes.object,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

export default withFeedPermission(Permissions.UPDATE)(EditButton);
